import React from 'react';
import { Col, Row, Tab } from 'react-bootstrap';
import Fade from 'react-reveal/Fade';

// ── What's included per tier ───────────────────────────────────────────────
const tierDetails = {
    0: { // Basic
        quote: '"A great start for businesses taking their first digital step."',
        features: [
            '3-Page Responsive Website',
            'Basic SEO Setup',
            'Contact Form Integration',
        ],
    },
    1: { // Standard
        quote: '"Everything you need to grow and stand out in the market."',
        features: [
            'Up to 10-Page Custom Website',
            'Advanced SEO & Analytics',
            'Social Media Integration',
        ],
    },
    2: { // Premium
        quote: '"Full-scale digital solutions crafted for industry leaders."',
        features: [
            'Unlimited Pages + E-Commerce',
            'Priority Support & Maintenance',
            'Custom API & Database Integration',
        ],
    },
};

const PricingCard = ({ data, id }) => {
    return (
        <Tab.Pane eventKey={id + 1}>
            <Row>
                {data.map(({ title, name, price }, index) => {
                    const tier = tierDetails[index] || tierDetails[0];
                    return (
                        <Col md={4} key={index}>
                            <Fade bottom duration={1800} distance='40px'>
                                <div className={`pricingCard pricingCard${id + 1}`}>
                                    <div className="pricingBox">
                                        <h4>{title}</h4>
                                        <p className="pricePlan">
                                            <span className={`ph${id + 1}`}>₹{price}/</span>month
                                        </p>
                                        <h5>{name}</h5>

                                        {/* Unique quote per tier */}
                                        <p className="planDescription" style={{
                                            fontStyle: 'italic',
                                            color: '#7254f6',
                                            fontWeight: '500',
                                            fontSize: '0.88rem',
                                            margin: '0.5rem 0 1rem',
                                            lineHeight: '1.5',
                                        }}>
                                            {tier.quote}
                                        </p>
                                    </div>

                                    {/* Unique features per tier */}
                                    {tier.features.map((feature, i) => (
                                        <li key={i}>
                                            <span className="checkIcon">✓</span> {feature}
                                        </li>
                                    ))}
                                </div>
                            </Fade>
                        </Col>
                    );
                })}
            </Row>
        </Tab.Pane>
    );
};

export default PricingCard;